/*
 * @Author: hujingyang
 * @Description: 重构Header
 * @LastEditors: yang chenglin
 */
import React, { useState } from 'react';
import { Breadcrumb } from '@alifd/next';
import style from './index.module.scss';
import { appHistory } from '@ice/stark-app';
import { event, store } from '@ice/stark-data';

/** 顶部Header组件 */
const Index = (): JSX.Element => {
  const [breadcrumb, setBreadcrumb] = useState([{ name: '', url: '/web/cjyx' }]);

  /** 路由重导向 */
  const pageRedirect = (url: string): void => {
    console.log(url);
    appHistory.push(url);
  };
  /** 设置面包屑 */
  const reSetBreadcrumb = (props) => {
    const newSetBreadcrumb = getBreadcrumbArr(props, []);
    store.set('newSetBreadcrumb', newSetBreadcrumb);
    setBreadcrumb(newSetBreadcrumb);
  };

  /** 递归拆解 面包屑对象 拼装为数组 */
  const getBreadcrumbArr = (
    params: { name: string; url: string; children: any },
    currentBreadcrumbArr: any,
  ): [{ name: string; url: string }] => {
    currentBreadcrumbArr.push({ name: params.name, url: params.url });
    return params.children
      ? getBreadcrumbArr(params.children, currentBreadcrumbArr)
      : currentBreadcrumbArr;
  };

  /** 监听 Breadcrumb */
  event.on('Breadcrumb', (props) => {
    reSetBreadcrumb(props);
  });

  return (
    <div className={style.douStoreHeader}>
      <div attr-intro="导航面包屑" className={style.breadcrumb}>
        <Breadcrumb separator="/">
          {breadcrumb.map((item, index) => {
            return (
              // 当前项是否为最后一项 ，最后一项不加载 超链接
              index === breadcrumb.length - 1 ? (
                <Breadcrumb.Item key={index}>{item.name}</Breadcrumb.Item>
              ) : (
                <Breadcrumb.Item
                  key={index}
                  onClick={() => pageRedirect(item.url)}
                >
                  {item.name}
                </Breadcrumb.Item>
              )
            );
          })}
        </Breadcrumb>
        <span
          attr-intro="面包屑最后一项巨化展示"
          className={style.currentPageName}
        >
          {breadcrumb[breadcrumb.length - 1].name}
        </span>
      </div>
    </div>
  );
};

export default Index;
